import { UrlHelper } from '@/modules/core/app/helpers/UrlHelper';
import DocumentUIService from '@/modules/core/app/services/DocumentUIService';
import { SupportChatflowClickedEventTracking } from '@/modules/guidancestep/models/segmentevents/SupportChatflowClickedEventTracking';

export class HubSpotConversationHelper {
  init(): void {
    // @ts-ignore
    window.hsConversationsSettings = {
      loadImmediately: false
    };

    this.setConversationsOnReady();
    this.onUserIteractsWithWidget();
  }

  setConversationsOnReady(): void {
    // @ts-ignore
    window.hsConversationsOnReady = [this.updateWidget];
  }

  updateWidget(): void {
    // @ts-ignore
    const status: Record<string, unknown> = window.HubSpotConversations?.widget?.status();

    if (status?.loaded) {
      // @ts-ignore
      window.HubSpotConversations?.widget?.refresh();
    } else {
      // @ts-ignore
      window.HubSpotConversations?.widget?.load();
    }
  }

  identify(props: Record<string, unknown>): void {
    // @ts-ignore
    window._hsq?.push(['identify', props]);
  }

  setPath(path: string): void {
    // @ts-ignore
    window._hsq?.push(['setPath', path]);
  }

  trackPageView(): void {
    // @ts-ignore
    window._hsq?.push(['trackPageView']);
  }

  refreshWidget(): void {
    // @ts-ignore
    window.HubSpotConversations?.widget?.refresh();
  }

  removeWidget(): void {
    // @ts-ignore
    window.HubSpotConversations?.widget?.remove();
  }

  onUserIteractsWithWidget(): void {
    /*
     * The userInteractedWithWidget event is triggered when the visitor interacts with the widget,
     * such as clicking to open the widget or closing the initial welcome message.
     * 
     * https://developers.hubspot.com/docs/api-reference/conversations-conversations-inbox-&-messages-v3/chat-widget-sdk#userinteractedwithwidget
     */

    // @ts-ignore
    window.HubSpotConversations?.on('userInteractedWithWidget', () => {
      this.dispatchSupportChatflowClickedEventTracking();
    });
  }

  dispatchSupportChatflowClickedEventTracking(): void {
    const stepId: string | null = UrlHelper.getQueryParamValueByKey(
      DocumentUIService.getUrl(),
      'key'
    );

    SupportChatflowClickedEventTracking.dispatch({ step_id: stepId });
  }
}

export default new HubSpotConversationHelper();
